export default "__VITE_ASSET__71a2aa04__"